import { z } from "zod/v4";

import { ExperienceDtoSchema } from "./experiences";
import { HistoryDtoSchema } from "./history";
import {
  ExperienceListVariationDtoSchema,
  ExperienceListWithOffersVariationDtoSchema,
} from "./variations";

export const ExperienceListDtoSchema = ExperienceDtoSchema.pick({
  archivedAtTs: true,
  audience: true,
  category: true,
  createdAtTs: true,
  currency: true,
  description: true,
  devicePreview: true,
  endedAtTs: true,
  experienceActions: true,
  experienceAnalysis: true,
  experiencePageTargeting: true,
  id: true,
  isDeleted: true,
  isExternal: true,
  isPreview: true,
  lastUpdateTs: true,
  linkBaseUrl: true,
  name: true,
  organizationId: true,
  pausedAtTs: true,
  productVariantCount: true,
  requiresLink: true,
  sourceAction: true,
  sourceExperienceId: true,
  startedAtTs: true,
  status: true,
  testTypes: true,
  type: true,
}).extend({
  history: HistoryDtoSchema.array(),
  previewPath: z.string(),
  variations: ExperienceListVariationDtoSchema.array(),
});

export type ExperienceListDto = z.infer<typeof ExperienceListDtoSchema>;

export const ExperienceListWithOffersDto = ExperienceListDtoSchema.extend({
  variations: ExperienceListWithOffersVariationDtoSchema.array(),
});
export type ExperienceListWithOffersDto = z.infer<
  typeof ExperienceListWithOffersDto
>;
